<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="インターネットFWプロファイル設定参照"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="text-right">
                <v-btn
                  v-permission.config
                  color="primary"
                  @click="showProfileInternetFwModify"
                >
                  変更
                </v-btn>
                <v-btn
                  v-permission.config
                  v-if="!internetFwProfileInfo.isPolicyInUse"
                  color="primary"
                  @click="deleteInternetFw"
                  class="ml-2"
                  >削除</v-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="名前"
                  :value="internetFwProfileInfo.profileInternetFwName"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <app-label-group
                  label="アプリケーション"
                  :value="
                    internetFwProfileInfo.applicationList.length
                      ? 'Select'
                      : 'any'
                  "
                />
              </v-col>
            </v-row>
            <template v-if="internetFwProfileInfo.applicationList.length">
              <v-row>
                <v-col cols="12">
                  <app-label-group label="選択アプリケーション" />
                </v-col>
              </v-row>
              <div>
                <v-table density="compact">
                  <thead class="v-table-head">
                    <tr>
                      <th class="text-center">アプリケーション</th>
                      <th class="text-center">カテゴリ</th>
                      <th class="text-center">サブカテゴリ</th>
                      <th class="text-center">テクノロジー</th>
                      <th class="text-center">リスク</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template
                      v-for="item in internetFwProfileInfo.applicationList"
                      :key="item.applicationSeq"
                    >
                      <tr>
                        <td>{{ item.applicationName }}</td>
                        <td>{{ item.category }}</td>
                        <td>{{ $filter.emptyTo(item.subcategory, "-") }}</td>
                        <td>{{ $filter.emptyTo(item.technology, "-") }}</td>
                        <td>{{ item.risk }}</td>
                      </tr>
                    </template>
                  </tbody>
                </v-table>
              </div>
            </template>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import { VueFinalModal } from "vue-final-modal";
import ProfileInternetFwEdit from "@/modals/applianceObject/ProfileInternetFwEdit.vue";
import type {
  DeleteInternetfwProfile,
  InternetfwProfileInfo,
} from "@/apis/InternetfwProfileApi";

export default defineComponent({
  name: "ProfileInternetFwReference",
  props: {
    profileInternetFwSeq: {
      type: String as PropType<string>,
      required: true,
    },
    type4Id: {
      type: String as PropType<string>,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isLoaded: false,
      internetFwProfileInfo: {} as InternetfwProfileInfo,
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    /** プロファイル(インターネットFW)情報の取得 */
    async load() {
      // プロファイル(インターネットFW)詳細データの取得
      if (!this.type4Id) {
        this.internetFwProfileInfo =
          await this.$api.internetfwProfileApi.getType1Profile(
            this.profileInternetFwSeq
          );
      } else {
        this.internetFwProfileInfo =
          await this.$api.internetfwProfileApi.getType4Profile(
            this.type4Id,
            this.profileInternetFwSeq
          );
      }
      // アプリケーション配列のソート対応
      this.internetFwProfileInfo.applicationList.sort((a, b) => {
        return this.$service.sortCompare(a, b, [["applicationName", "asc"]]);
      });
    },
    /** インターネットFWを編集 */
    async showProfileInternetFwModify() {
      await this.$modal.show(ProfileInternetFwEdit, {
        internetFwProfileInfo: this.internetFwProfileInfo,
        type4Id: this.type4Id,
        profileInternetFwSeq: this.profileInternetFwSeq,
        profileInternetFwKeyId:
          this.internetFwProfileInfo.profileInternetFwKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /** インターネットFWを削除 */
    async deleteInternetFw() {
      // 確認ダイアログの表示
      await this.$confirm("プロファイルを削除します。よろしいですか？");

      // リクエストデータの設定
      const reqData: DeleteInternetfwProfile = {
        profileInternetFwSeqList: [this.profileInternetFwSeq],
        profileInternetFwKeyId:
          this.internetFwProfileInfo.profileInternetFwKeyId,
        note: null,
      };

      // プロファイル(インターネットFW)削除APIを呼び出す
      if (!this.type4Id) {
        await this.$api.internetfwProfileApi.deleteType1Profile(reqData);
      } else {
        await this.$api.internetfwProfileApi.deleteType4Profile(
          this.type4Id,
          reqData
        );
      }
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>
